import { CarouselSlider } from "common/components";
import type { ScreenSize } from "common/styles/mediaQueries/types";
import type { TopicBackLabelData } from "context/session/sessionTypes";
import { TopicTile } from "domains/topic/components/topicTile/TopicTile";
import { useMedia } from "domains/viewport/useMedia";
import type { Topic } from "entities/topics/types";

type TopicSliderProps = {
  hideFollowAction?: boolean;
  numberOfItems?: Partial<Record<ScreenSize, number>>;
  topicBack: TopicBackLabelData;
  topics: Topic[];
};

export const TopicSlider = ({
  hideFollowAction = false,
  numberOfItems = { small: 1, medium: 2, large: 3, extraLarge: 4, enormous: 5 },
  topicBack,
  topics = [],
}: TopicSliderProps) => {
  const length = useMedia(numberOfItems, 1);
  return (
    <CarouselSlider numberOfItems={length}>
      {topics.map((topic) => (
        <TopicTile
          key={topic.id}
          hideFollowAction={hideFollowAction}
          topicId={topic.id}
          topicName={topic.name}
          provider={topic.provider}
          topicBack={topicBack}
          attachment={topic.attachment ?? undefined}
          canEdit={topic.can_edit ?? false}
          isCustom={topic.is_custom ?? false}
          isNew={topic.is_new ?? false}
          isFollowing={topic.is_following ?? false}
          imageUrl={topic.images?.x_small}
        />
      ))}
    </CarouselSlider>
  );
};
